import { Action } from '@ngrx/store';
import { Kiosk } from '../kiosk/kiosk.model';

export enum KioskWsActionTypes {
  LocalCreateKioskSuccessWs = '[Kiosk WS] Local Create Kiosks Success',
  LocalCreateKioskFailureWs = '[Kiosk WS] Local Create Kiosks Failure',
  LocalUpdateKioskSuccessWs = '[Kiosk WS] Local Update Kiosks Success',
  LocalUpdateKioskFailureWs = '[Kiosk WS] Local Update Kiosks Failure',
  LocalRemoveKioskSuccessWs = '[Kiosk WS] Local Remove Kiosks Success',
  LocalRemoveKioskFailureWs = '[Kiosk WS] Local Remove Kiosks Failure',
  GlobalCreateKioskSuccessWs = '[Kiosk WS] Global Create Kiosks Success',
  GlobalUpdateKioskSuccessWs = '[Kiosk WS] Global Update Kiosks Success',
  GlobalRemoveKioskSuccessWs = '[Kiosk WS] Global Remove Kiosks Success',
}

export class LocalCreateKioskSuccessWs implements Action {
  readonly type = KioskWsActionTypes.LocalCreateKioskSuccessWs;

  constructor(public payload: { id: string; correlation_id: string }) {}
}

export class LocalCreateKioskFailureWs implements Action {
  readonly type = KioskWsActionTypes.LocalCreateKioskFailureWs;

  constructor(public payload: { correlation_id: string; message: string }) {}
}

export class LocalUpdateKioskSuccessWs implements Action {
  readonly type = KioskWsActionTypes.LocalUpdateKioskSuccessWs;

  constructor(public payload: { id: string; correlation_id: string }) {}
}

export class LocalUpdateKioskFailureWs implements Action {
  readonly type = KioskWsActionTypes.LocalUpdateKioskFailureWs;

  constructor(public payload: { correlation_id: string; message: string }) {}
}

export class LocalRemoveKioskSuccessWs implements Action {
  readonly type = KioskWsActionTypes.LocalRemoveKioskSuccessWs;

  constructor(public payload: { correlation_id: string }) {}
}

export class LocalRemoveKioskFailureWs implements Action {
  readonly type = KioskWsActionTypes.LocalRemoveKioskFailureWs;

  constructor(public payload: { correlation_id: string; message: string }) {}
}

export class GlobalCreateKioskSuccessWs implements Action {
  readonly type = KioskWsActionTypes.GlobalCreateKioskSuccessWs;
}

export class GlobalUpdateKioskSuccessWs implements Action {
  readonly type = KioskWsActionTypes.GlobalUpdateKioskSuccessWs;

  constructor(public payload: { kiosk: Kiosk }) {}
}

export class GlobalRemoveKioskSuccessWs implements Action {
  readonly type = KioskWsActionTypes.GlobalRemoveKioskSuccessWs;

  constructor(public payload: { id: Kiosk['id'] }) {}
}

export type KioskWsActions =
  | LocalCreateKioskSuccessWs
  | LocalCreateKioskFailureWs
  | LocalUpdateKioskSuccessWs
  | LocalUpdateKioskFailureWs
  | LocalRemoveKioskSuccessWs
  | LocalRemoveKioskFailureWs
  | GlobalCreateKioskSuccessWs
  | GlobalUpdateKioskSuccessWs
  | GlobalRemoveKioskSuccessWs;
